import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ReservationService {
  reservation: any;

  // tslint:disable-next-line:variable-name
  constructor() { }

}

